/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Moving_Cod_TransformInputs */

const fr_fair_moving_cod_transform = /** @type {(inputs: Fair_Moving_Cod_TransformInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir plus`)
};

/**

* @param {Fair_Moving_Cod_TransformInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fair_moving_cod_transform = /** @type {((inputs?: Fair_Moving_Cod_TransformInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Moving_Cod_TransformInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fair_moving_cod_transform(inputs)
});